import './Home.css';
import './Styles/home2.css'
import Logo from '../../image/Logo Final.png';
import { FaYoutube , FaInstagram,FaTiktok} from 'react-icons/fa';
import video from '../../video/scarlet.mp4';
import {AiFillHeart} from 'react-icons/ai'


const Home = () =>{
   return(
       <section id = 'Home' >
          <video 
       autoPlay
       loop
       muted
       onReady
       style={{
         position: 'fixed',
         width: '100%',
         height: '100%',
         zIndex: -1,
         objectFit: 'cover'
       }}
      >
         <source  src = {video} type="video/mp4"/>
       </video>
           <div className = 'logo_box'>
                <img src = {Logo} alt = 'Logo' className = 'logo'/><br/><br/>
                <span className = 'name'>Marvel Earth 616</span><br/><br/>
                <span className = 'social'>Socials</span><br/>
           </div>     
           <div className = 'container'>
                <a href ="https://instagram.com/marve.learth616?utm_medium=copy_link">
                    <div className="social_media instagram">
                        <span>Instagram</span>
                        <FaInstagram className = 'icon instagram_icon'/>
                    </div>
                </a>      
                <a href ="https://youtube.com/channel/UCp2Jqo2qm8-fw7HbvsSIpOg">
                    <div className="social_media youtube">
                        <span>YouTube</span>
                        <FaYoutube className = 'icon youtube_icon'/>
                    </div>
                </a>   
                <a href ="https://vm.tiktok.com/ZSJwStVVR/">
                    <div className="social_media tiktok">
                        <span>TikTok</span>
                        <FaTiktok className = 'icon tiktok_icon'/>
                    </div>
                </a> 

           </div>
            <div className='creator'>
              <span className='creator'>Created By Rain</span><AiFillHeart className='heart'/>
            </div>
       </section>
   )
};

export default Home;